import React from "react";
import RequestsPage from "../RequestsPage";

export default function WorkerRequests() {
  return <RequestsPage role="worker" />;
}
